import axios from 'axios'

const defaultConfig = {
  method: 'get',
  timeout: 2000
}

function request (config) {
  const resultConfig = Object.assign({}, defaultConfig, config)

  return axios(resultConfig)
}

export default request
